/* eslint-disable @typescript-eslint/no-unused-vars */
// 日志
import { SLQ_ENV_MAP } from '@/services/track/configure'
import { APP_ID } from '@/services/track/constants'
import Cookies from 'js-cookie'
import { eatError } from '../function'

/** 默认配置 */
const DefaultEventOptions = {
  act: 'webappuserlogger',
  release: process.env.TRACE_RELEASE,
  env: SLQ_ENV_MAP[process.env.APP_ENV],
  project_id: 'weblogger',
  app_id: APP_ID,
  ua: navigator.userAgent,
  user_session_id: window.sessionStorage.getItem('fontendSessionId'),
}

let sceneList = ['init']
let userInfo = { sellerId: '' }
let jdpTracker = undefined
const getTracker = async () => {
  if (!jdpTracker) {
    const { tracker } = await import('@yy/jdp-tracker')
    tracker.setOptions({ useHttps: process.env.NODE_ENV !== 'production' })
    tracker.initInstance()
    jdpTracker = tracker
  }

  return jdpTracker
}

interface LogData {
  data?: any
  type: string
}
interface RequestLogData extends LogData {
  type: 'request'
  url: string
  trace_id: string
  header?: any
}
interface ResponseLogData extends LogData {
  type: 'response'
  url: string
  trace_id: string
  tti: number
  data: any
}
interface WebsocketLogData extends LogData {
  type: 'websocket'
  data: any
}
interface NavigationLogData extends LogData {
  type: 'navigation'
  /** 旧链接 */
  data: string
}
interface LoadLogData extends LogData {
  type: 'load'
  /**建立链接时间 */
  // connectTime?: number
  /**域名解析时间 */
  // domainLookupTime?: number
  /**响应时间 */
  tti?: number
}

interface ActionLogData extends LogData {
  type: 'action'
  event_type: string
  event_target?: string
}

const track = async (data: RequestLogData | ResponseLogData | WebsocketLogData | NavigationLogData | LoadLogData | ActionLogData) => {
  const tracker = await getTracker()
  const reportData = {
    ...data,
    ...DefaultEventOptions,
    href: window.location.href,
    uid: Cookies.get('osudb_uid'),
    seller_id: userInfo.sellerId,
    scene_list: sceneList.join(','),
  }
  if (process.env.APP_ENV === 'product') {
    Object.keys(reportData).forEach((key) => {
      if (typeof reportData[key] === 'object' && reportData[key] !== null) reportData[key] = JSON.stringify(reportData[key])
    })
    if (reportData.data?.length > 1000) reportData.data = reportData.data.slice(0, 1000)
    tracker.report(reportData)
  } else {
    // eslint-disable-next-line no-console
    console.log(reportData)
  }
}

const _logger = {
  initUserInfo: (info: { sellerId: string }) => (userInfo = info),
  setScene: (s: string) => sceneList.push(s),
  startScene: (s: string) => (sceneList = [s]),
  track,
  log: track as (data: LogData) => void,
}

// 对外暴露的所有方法都不能抛错
Object.keys(_logger).forEach((key) => {
  _logger[key] = eatError(_logger[key])
})

export const logger = _logger
;(function () {
  try {
    const selfSessionId = Math.random().toString(36).slice(-8)
    let openerSessionId = null
    try {
      openerSessionId = window.opener?.sessionStorage.getItem('fontendSessionId')
    } catch (error) {}
    window.sessionStorage.setItem('fontendSessionId', openerSessionId ? `${openerSessionId}-${selfSessionId}` : selfSessionId)

    const performanceNavigationTiming = performance.getEntriesByType('navigation')?.[0] as PerformanceNavigationTiming
    logger.track({ type: 'load', tti: performanceNavigationTiming?.responseStart })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
})()
